/**
 * @description API calls const
 */
export const API_CALLS_CONST = {
    ADD_CELL_INDEPENDENT_CONTAINER: "ADD_CELL_INDEPENDENT_CONTAINER",
    UPDATE_CELL_INDEPENDENT_CONTAINER: "UPDATE_CELL_INDEPENDENT_CONTAINER",
    ADD_CELL_INDEPENDENT_CONTAINER_CHILD: "ADD_CELL_INDEPENDENT_CONTAINER_CHILD",
    UPDATE_CELL_INDEPENDENT_CONTAINER_CHILD: "UPDATE_CELL_INDEPENDENT_CONTAINER_CHILD",
    REMOVE_CELL_INDEPENDENT_CONTAINER_CHILD: "REMOVE_CELL_INDEPENDENT_CONTAINER_CHILD",
    REMOVE_CELL_INDEPENDENT_CONTAINER: "REMOVE_CELL_INDEPENDENT_CONTAINER",
    REMOVE_ALL_CELL_INDEPENDENT_PLUGINS: "REMOVE_ALL_CELL_INDEPENDENT_PLUGINS",
    ADD_CONNECTOR: "ADD_CONNECTOR",
    DELETE_CONNECTOR: "DELETE_CONNECTOR",
    UPDATE_CONNECTOR_LABEL: "UPDATE_CONNECTOR_LABEL",
    UPDATE_CONNECTOR_DATA: "UPDATE_CONNECTOR_DATA",
    DELETE_PLUGIN: "DELETE_PLUGIN",
    UPDATE_PLUGIN_LABEL: "UPDATE_PLUGIN_LABEL",
    SELECT_CONNECTOR: "SELECT_CONNECTOR",
    SELECT_PLUGIN: "SELECT_PLUGIN",
    UPDATE_PLUGIN_STATE: "UPDATE_PLUGIN_STATE",
    UPDATE_PLUGIN_DESIGN: "UPDATE_PLUGIN_DESIGN",
    ADD_ANCHORED_PLUGIN: "ADD_ANCHORED_PLUGIN",
    UPDATE_ANCHORED_PLUGIN: "UPDATE_ANCHORED_PLUGIN"
};
